// noinspection JSUnusedGlobalSymbols
// File auto-generated on: 2025-06-03T15:14:56.942Z

export type GetContentByContentTypeAndContentNameApiResponse =
  /** status 200 OK */ ContentGetContentResponse;
export type GetContentByContentTypeAndContentNameApiArg = {
    /** Content block name */
    "content-name": string;
    /** Content block type */
    "content-type": ContentType;
};
export type ContentMeta = {
    content?: null | string;
    field?: ContentType;
    title?: null | string;
};
export type ContentGetContentResponse = {
    "auth-dependent"?: boolean;
    content?: null | string;
    footer?: null | string;
    header?: null | string;
    meta?: ContentMeta[];
    type?: ContentType;
};
export enum ContentType {
    Block = "block",
    Page = "page",
}
